export interface ContactInfoItem {
  id: 'email' | 'website' | 'x' | 'linkedin';
  label: string;
  value: string;
  href: string;
  icon: string;
  enabled: boolean;
}

export interface ContactInfoConfig {
  items: ContactInfoItem[];
}

export const defaultContactInfo: ContactInfoConfig = {
  items: [
    {
      id: 'email',
      label: 'Email',
      value: 'info@zobu-consulting.com',
      href: 'mailto:info@zobu-consulting.com',
      icon: 'ri-mail-send-line',
      enabled: true,
    },
    {
      id: 'website',
      label: 'Website',
      value: 'www.zobu-consulting.com',
      href: 'https://www.zobu-consulting.com/',
      icon: 'ri-global-line',
      enabled: true,
    },
    {
      id: 'x',
      label: 'Twitter / X',
      value: '@zobu_consulting',
      href: 'https://x.com/zobu_consulting',
      icon: 'ri-twitter-x-line',
      enabled: true,
    },
    {
      id: 'linkedin',
      label: 'LinkedIn',
      value: 'Zobu Consulting',
      href: 'https://www.linkedin.com/company/2218967/',
      icon: 'ri-linkedin-line',
      enabled: true,
    },
  ],
};
